import ITEM from '../../../../DOM/LIST/item/ITEM.js';
import { LISTITEMELEMENT } from '../../../../../enums/LISTITEMELEMENT.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
// Model Structure
export const ddAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['style']
]);
export const ddData = makeDataStruct([
    ['text', '']
]);
export const ddModel = makeStruct([
    ['attributes', ddAttr],
    ['data', ddData]
]);
// Simplified Model
export function dd(text, className, style) {
    return ddModel(ddAttr(className, style), ddData(text));
}
/** A Definition Description (DD) belonging to a Definition List */
export default class DD extends ITEM {
    constructor(node, model) {
        super(node, LISTITEMELEMENT.DD, model);
        this.setInnerHTML(model.data.text);
    }
}
